import React from "react";
import styles from "../../styles/StackButtons.module.css";

interface StackButtonsProps {
  onTopClick: (e: React.MouseEvent) => void;
  onBottomClick: (e: React.MouseEvent) => void;
  topTitle?: string;
  bottomTitle?: string;
  topLabel?: React.ReactNode;
  bottomLabel?: React.ReactNode;
}

/**
 * StackButtons component - Displays two stacked buttons for add/edit operations
 */
export default function StackButtons({
  onTopClick,
  onBottomClick,
  topTitle = "Add new item",
  bottomTitle = "Edit group",
  topLabel = "＋",
  bottomLabel = "✎",
}: StackButtonsProps) {
  return (
    <div className={styles.stackButtons}>
      <button className={styles.stackBtn} onClick={onTopClick} title={topTitle}>
        {topLabel}
      </button>
      <button
        className={styles.stackBtn}
        onClick={onBottomClick}
        title={bottomTitle}
      >
        {bottomLabel}
      </button>
    </div>
  );
}
